import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { PostKey } from './keys';
import { PostService } from './postService';

export function useGetPost(id?: number, enabled = true) {
  const getPostQuery = useQuery({
    queryKey: [PostKey.POSTS, id],
    queryFn: () => PostService.getPost(id).then((response) => response.data),
    enabled: enabled && !!id,
  });

  const errorMessage = useErrorMessage(getPostQuery.error);
  return { ...getPostQuery, errorMessage };
}
